import secureLocalStorage from "react-secure-storage";
import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";

export default class OwnerComponent extends GridCell {
  constructor(props){
    super(props);
    this.state={
dropdown:props.dropDownData
    }
  }
  handleChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  }
  handleEditCell = () => {
    if(this.props.dataItem.isOpen==="Open" || this.props.dataItem.isOpen===true){
    if (this.props.dataItem.riskRegisterActionId) {
    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
    }
  };

  handlefilter=(event,dropdown)=>{
    const element=dropdown.slice();
    const value=event.filter
   const filteredData=filterBy(element,value)  
    console.log("filtereddata",filteredData)
    this.setState({
      dropdown:filteredData
    })
    console.log("dropdown",this.state.dropdown)

  }
  render() {
    const value = this.props.dataItem[this.props.field];
    const { dataItem, field } = this.props;
    const owner = dataItem.owner;
    const ownerId = dataItem.userId;
    const riskOwnerId=this.props.riskDetails?this.props.riskDetails.userId:null;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));

    const selectedValue = value
      ? this.props &&
        this.props.dropDownData.find((item) => item.text === value)
      : "";
      const list= this.props.dropDownData ;
    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {

      return (
        <td>
          <DropDownList
            style={{ width: "100px" }}
            onChange={this.handleChange.bind(this)}
            value={selectedValue ? selectedValue : value}
            data={this.props ? this.state.dropdown : []}
            valueField="value"
            textField="text"
            filterable={true}
            onFilterChange={(e)=>this.handlefilter(e,list)}
            opened={true}
          />
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if ((loginUserId === owner || loginUserId===riskOwnerId || loginUserId === ownerId) && this.props.dataItem.isOpen === true) {
        return (
          
          <td onClick={this.handleEditCell}>
            {" "}
            {value === null || value == undefined
              ? ""
              : value.text
              ? value.text == "TENANT"
                ? secureLocalStorage.getItem("userName")
                : value.text
              : value == "TENANT"
              ? secureLocalStorage.getItem("userName")
              : value}
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ||
          this.props.dataItem.isOpen == false ? (
          <td>
            {" "}
            {value === null || value == undefined
              ? ""
              : value.text
              ? value.text == "TENANT"
                ? secureLocalStorage.getItem("userName")
                : value.text
              : value == "TENANT"
              ? secureLocalStorage.getItem("userName")
              : value}
          </td>
        ) : (
          <td onClick={this.handleEditCell}>
            {" "}
            
            {value === null || value == undefined
              ? ""
              : value.text
              ? value.text == "TENANT"
                ? secureLocalStorage.getItem("userName")
                : value.text
              : value == "TENANT"
              ? secureLocalStorage.getItem("userName")
              : value}
          </td>
        );
      }
    }
  }
}

